// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3os1G","text":"SelectPayment_text__2WeOZ","title":"SelectPayment_title__1ydCT","btn":"SelectPayment_btn__2A6Cw"};